import { render, staticRenderFns } from "./VideoAssets.vue?vue&type=template&id=6f52bbc8&scoped=true&"
import script from "./VideoAssets.vue?vue&type=script&lang=js&"
export * from "./VideoAssets.vue?vue&type=script&lang=js&"
import style0 from "./VideoAssets.vue?vue&type=style&index=0&id=6f52bbc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f52bbc8",
  null
  
)

export default component.exports